/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".page-loader[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:5px}.page-loader.page-loader--loading[_ngcontent-%COMP%]   .page-loader__progress[_ngcontent-%COMP%]{-webkit-animation:1.5s infinite progress;animation:1.5s infinite progress}.page-loader__progress[_ngcontent-%COMP%]{width:0%;height:100%;border-radius:0 8px 8px 0;background-color:#43425d;-webkit-animation:none;animation:none}@-webkit-keyframes progress{0%{width:0}100%{width:100%}}@keyframes progress{0%{width:0}100%{width:100%}}"];
export { styles as styles };
